export default "__VITE_ASSET__CvX5b0ao__"